import { ViewEntityDialog } from "components/viewDialog/ViewEntityDialog";
import { IViewEntityField } from "components/viewDialog/ViewEntityDialog.types";
import { IViewWorkspaceProps } from "./ViewWorkspace.types";

const formatDateString = (dateString?: string): string => {
  if (!dateString) return "-";
  try {
    const timestamp = Number(dateString);
    if (isNaN(timestamp)) return "-";
    return new Date(timestamp * 1000).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return "-";
  }
};

export const ViewWorkspace = (props: IViewWorkspaceProps): JSX.Element => {
  const { workspace, isOpen, onDismiss } = props;

  const ownerNames =
    workspace.owners?.map((owner) => owner.displayName).join(", ") || "-";
  const memberNames =
    workspace.teamMembers?.map((member) => member.displayName).join(", ") ||
    "-";

  const fields: IViewEntityField[] = [
    { label: "Name", value: workspace.name },
    { label: "Description", value: workspace.clientName || "-" },
    { label: "Owner", value: ownerNames },
    { label: "Members", value: memberNames },
    { label: "Last Updated", value: formatDateString(workspace.updatedAt) },
  ];

  return (
    <ViewEntityDialog
      isOpen={isOpen}
      onDismiss={onDismiss}
      title="View Workspace"
      fields={fields}
      compact
    />
  );
};
